import React from 'react';
import PropTypes from 'prop-types';
import styles from './PauseSlideContentV13.css';

function PauseSlideContentV13({ imageSrc, title, description }) {
    return (
        <div className={styles.form}>
            <div className={styles.imageWrapper}>
                <img src={imageSrc} alt='' className={styles.image} />
            </div>
            <h2 className={styles.heading}>{title}</h2>
            <div className={styles.description}>{description}</div>
        </div>
    );
}

PauseSlideContentV13.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    description: PropTypes.node.isRequired
};

export {
    PauseSlideContentV13
};
